import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { LocationArea } from '../../../../../../../models/location';
import { LocationService } from '../../../../../../../services/location/location.service';

@Component({
  selector: 'app-remove-location-area-modal',
  templateUrl: './remove-location-area-modal.component.html',
  styleUrls: ['./remove-location-area-modal.component.css']
})
export class RemoveLocationAreaModalComponent implements OnInit {

  @Input() locationArea: LocationArea;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingRemove = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public locationService: LocationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleRemove() {
    this.loadingRemove = true;

    this.errorMessage = '';
    this.errors = {};

    this.locationService
      .deleteLocationArea(this.locationArea.url)
      .then(() => {
        this.savedCallback({
          text: this.locationArea.name + ' removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove areas.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRemove = false; });
  }

}
